import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import moment from 'moment';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import colors from '@/styles/color.scss';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getRecordInfo, getRecordList } from '@blade-sxp/portrait-management/api/portrait';
import { LibraryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { Scale } from '@blade/common/utils/auto-scale';
const { zh, en } = lang;
let default_1 = class default_1 extends Vue {
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    defaultPageSize = [10, 20, 50, 100, 200];
    defaultTableMinWidth = {
        imageName: 184 * Scale,
        userName: 180 * Scale,
        userId: 100 * Scale,
        portrait: 100 * Scale,
        state: 120 * Scale,
        failReason: 436 * Scale,
    };
    cellBackground = colors.colorBoxBg;
    filterLibraryStatus = [];
    get tableLabelUserName() {
        return this.formData.libraryType === LibraryTypeEnum.AUTO_FEATURE ? this.$t('plateNumber') : this.$t('name');
    }
    get tableLabelPassId() {
        return this.formData.libraryType === LibraryTypeEnum.AUTO_FEATURE ? this.$t('ownerId') : this.$t('passId');
    }
    initI18n() {
        this.filterLibraryStatus = [
            { text: String(this.$t('successed')), value: 'SUCCESS' },
            { text: String(this.$t('failure')), value: 'FAIL' },
            { text: String(this.$t('increasing')), value: 'INCREASING' },
        ];
    }
    formData = {
        fileName: '',
        creator: '',
        updateAt: '',
        status: '',
        num: '',
        allNum: '',
        libraryType: LibraryTypeEnum.PORTRAIT_LIBRARY,
    };
    // table
    keyword = '';
    tableLoading = false;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
        state: undefined,
    };
    tableList = [];
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    /** 身份照片最大宽度 */
    get idPhotoMaxWidth() {
        return 240 * Scale;
    }
    /** 身份照片最大高度 */
    get idPhotoMaxHeight() {
        return 240 * Scale;
    }
    thousandthFormatter(e) {
        return String(e.vehicleNumber).replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,');
    }
    mounted() {
        this.initI18n();
        this.getFormData();
        this.getList();
    }
    onSearch() {
        this.pagination.page = 1;
        this.getList();
    }
    // 当表格的筛选条件发生变化的时候会触发该事件
    handleFilterChange(e) {
        console.log(e);
        if (e.state && e.state instanceof Array && e.state.length > 0)
            this.pagination.state = e.state[0];
        else
            this.pagination.state = undefined;
        this.getList();
    }
    // pageSize 改变时会触发
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getList();
    }
    // currentPage 改变时会触发
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getList();
    }
    getParams() {
        return {
            imageName: this.keyword,
            taskId: this.$route.query.taskId,
            page: this.pagination.page,
            size: this.pagination.size,
            state: this.pagination.state,
        };
    }
    // 获取table list
    getList() {
        this.tableLoading = true;
        try {
            const params = this.getParams();
            getRecordList(params)
                .then((res) => {
                const { list, total } = res;
                this.tableList = list;
                this.pagination.total = total;
            })
                .finally(() => {
                this.tableLoading = false;
            });
        }
        catch (error) {
            this.tableLoading = false;
            console.log('err', error);
        }
    }
    // 获取formData 数据
    getFormData() {
        const id = this.$route.query.taskId || 0;
        getRecordInfo(id).then((res) => {
            console.log('resresres', res);
            const { creatorName, fileName, state, updateTime, libraryType } = res;
            this.formData = {
                fileName,
                creator: creatorName,
                updateAt: updateTime,
                status: state.state,
                num: state.validNum,
                allNum: state.picNum,
                libraryType,
            };
        });
    }
    // 格式化时间
    formatDate(time) {
        return moment(new Date(time)).format('yyyy-MM-DD HH:mm:ss');
    }
    // 格式化状态
    getStatusText(state) {
        switch (state) {
            case 'PROCESS_COMPLETED':
            case 'UPLOAD_COMPLETED':
                return this.$t('successed');
            case 'PROCESS_FAILED':
                return this.$t('processFailed');
            case 'PROCESS_INTERRUPTED':
                return this.$t('processInterrupted');
            case 'UPLOADING':
                return this.$t('uploading');
            default:
                return '';
        }
    }
    getStateText(state) {
        if (state === 'SUCCESS') {
            return this.$t('successed');
        }
        else if (state === 'INCREASING') {
            return this.$t('increasing');
        }
        else {
            return this.$t('failure');
        }
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: {
                en: {
                    creator: 'Creator',
                    updateAt: 'Update At',
                    portraitFileName: 'Portrait File Name',
                    totalPortraits: 'Valid Portraits/Total Portraits',
                    picturesOfFile: 'Pictures of File',
                    pictureName: 'Picture Name',
                    passId: 'Pass ID ',
                    successed: 'Successed',
                    increasing: 'To be added',
                    failure: 'Failure',
                    uploadFailed: 'Upload Failed',
                    processInterrupted: 'Process Interrupted',
                    uploading: 'Uploading',
                    processFailed: 'Process Failed',
                    state: 'Status',
                    ...en,
                },
                zh: {
                    creator: '上传人',
                    updateAt: '更新时间',
                    totalPortraits: '有效图数量/总图数量',
                    picturesOfFile: '图片详情',
                    pictureName: '图片名称',
                    passId: '有效ID ',
                    successed: '上传入库成功',
                    increasing: '待添加',
                    failure: '失败',
                    uploadFailed: '上传错误',
                    processInterrupted: '入库中断',
                    uploading: '上传中',
                    processFailed: '入库错误',
                    state: '状态',
                    ...zh,
                },
            },
        },
        components: { BlurPicture, CombinedPicture, InputSearch },
    })
], default_1);
export default default_1;
